export const CUSTOMER_LOGIN_ATTEMPT = 'petdata/CUSTOMER_LOGIN_ATTEMPT';
export const CUSTOMER_LOGIN_SUCCESS = 'petdata/CUSTOMER_LOGIN_SUCCESS';
export const CUSTOMER_LOGIN_FAIL = 'petdata/CUSTOMER_LOGIN_FAIL';
export const CUSTOMER_LOGOUT = 'petdata/CUSTOMER_LOGOUT';

export const CUSTOMER_CONTEXT_RECEIVED = 'petdata/CUSTOMER_CONTEXT_RECEIVED';

export const TOKEN_LOGIN_SUCCESS = 'petdata/TOKEN_LOGIN_SUCCESS';

export const SET_ACTIVE_SUBSCRIPTION = 'petdata/SET_ACTIVE_SUBSCRIPTION';

export const UPDATE_LABEL_STYLES = 'petdata/UPDATE_LABEL_STYLES';
export const UPDATE_LABEL_LOGOS = 'petdata/UPDATE_LABEL_LOGOS';
export const UPDATE_LABEL_OFFSET = 'petdata/UPDATE_LABEL_OFFSET';

export const PASSWORD_CHANGE_SUCCESS = 'petdata/PASSWORD_CHANGE_SUCCESS';
export const FORGOT_PASSWORD_SENT = 'petdata/FORGOT_PASSWORD_SENT';

export const SHOW_ERROR_MODAL = 'petdata/SHOW_ERROR_MODAL';

export const SHOW_DEMO_MODAL = 'petdata/SHOW_DEMO_MODAL';
export const HIDE_DEMO_MODAL = 'petdata/HIDE_DEMO_MODAL';


/** WEBPACK FOOTER **
 ** ./src/modules/customer/actionTypes.js
 **/